import React, { useRef, useEffect } from "react";
import CustomInput from "./CustomInput";
import moment from "moment";

export default function CustomDatePicker({ inputprops, dateObj }) {
  const dateInputRef = useRef(null);
  const containerRef = useRef(null);

  useEffect(() => {
    if (!dateInputRef.current || !containerRef.current) return;

    const handleClickOutside = (event) => {
      if (containerRef.current && !containerRef.current.contains(event.target)) {
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  const openDatePicker = () => {
    if (dateInputRef.current) {
      dateInputRef.current.focus();

      try {
        dateInputRef.current.showPicker();
      } catch (error) {
        setTimeout(() => {
          if (dateInputRef.current) {
            const event = new MouseEvent("click", {
              view: window,
              bubbles: true,
              cancelable: true,
            });
            dateInputRef.current.dispatchEvent(event);
          }
        }, 10);
      }
    }
  };

  const handleClick = () => {
    openDatePicker();
  };

  const formattedDateValue = dateObj.date ? moment(dateObj.date, "YYYY-MM-DD").format("YYYY-MM-DD") : "";

  return (
    <div className="relative custom-input-datepicker-container w-full" ref={containerRef} style={{ position: "relative" }} onClick={handleClick}>
      {/* Hidden native date input that actually handles the date picking */}
      <input
        type="date"
        ref={dateInputRef}
        className="absolute w-0 h-0 opacity-0 overflow-hidden"
        style={{ position: "absolute", top: "-100px" }}
        onChange={(e) => {
          const syntheticEvent = {
            target: {
              name: inputprops.name,
              value: e.target.value,
            },
          };
          dateObj.setDate(syntheticEvent);
        }}
        value={formattedDateValue}
      />

      {/* Visible custom input */}
      <div className="w-full cursor-pointer">
        <CustomInput
          inputprops={{
            ...inputprops,
            readOnly: true,
            value: dateObj.date ? moment(dateObj.date, "YYYY-MM-DD").format("DD/MM/YYYY") : inputprops.value || "",
          }}
        />
      </div>

      {/* Calendar icon */}
    </div>
  );
}
